import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";
import api from "@/lib/api";

const shuffle = (arr) => arr.map((v) => [Math.random(), v]).sort((a, b) => a[0] - b[0]).map(([, v]) => v);

export default function Testimonials({ variant = "light", className = "", count = 1 }) {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);

  useEffect(() => {
    let active = true;
    api.get("/testimonials")
      .then(({ data }) => { if (active) setItems(shuffle(data.testimonials || [])); })
      .catch(() => { /* silenzioso */ });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (count > 1 || items.length < 2) return;
    const t = setInterval(() => setI((n) => (n + 1) % items.length), 5500);
    return () => clearInterval(t);
  }, [items.length, count]);

  if (items.length === 0) return null;
  const dark = variant === "dark";

  if (count > 1) {
    const picks = items.slice(0, count);
    return (
      <div data-testid="testimonial-grid" className={`grid gap-4 sm:grid-cols-2 ${className}`}>
        {picks.map((t) => (
          <div key={t.id} data-testid="testimonial-card"
            className={`relative overflow-hidden rounded-2xl px-5 py-4 ${dark ? "bg-white/12" : "bg-[#C17F59]/8"}`}>
            <Quote className={`absolute right-3 top-3 h-8 w-8 ${dark ? "text-white/15" : "text-[#C17F59]/15"}`} />
            <p className={`text-sm leading-relaxed ${dark ? "text-white/90" : "text-[#2D2825]"}`}>“{t.commento}”</p>
            <p className={`mt-2 text-xs uppercase tracking-[0.2em] ${dark ? "text-white/60" : "text-[#C17F59]"}`}>{t.nome}</p>
          </div>
        ))}
      </div>
    );
  }

  const t = items[i];

  return (
    <div data-testid="testimonial-rotator"
      className={`relative overflow-hidden rounded-2xl px-5 py-4 ${className} ${dark ? "bg-white/12" : "bg-[#C17F59]/8"}`}>
      <Quote className={`absolute right-3 top-3 h-8 w-8 ${dark ? "text-white/15" : "text-[#C17F59]/15"}`} />
      <AnimatePresence mode="wait">
        <motion.div key={t.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.45 }}>
          <p data-testid="testimonial-text" className={`text-sm leading-relaxed ${dark ? "text-white/90" : "text-[#2D2825]"}`}>
            “{t.commento}”
          </p>
          <p data-testid="testimonial-name" className={`mt-2 text-xs uppercase tracking-[0.2em] ${dark ? "text-white/60" : "text-[#C17F59]"}`}>
            {t.nome}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
